/* c8 ignore start */
import { i18n } from "@/i18n.js";
import { SIDENAV_GROUP_BY } from "@/constants";
import { SAT_SERVICE } from "@/utils/services";

const MSP_NAV_ITEMS = [
  {
    order: 4,
    groupBy: SIDENAV_GROUP_BY.EPSILON,
    label: i18n.global.t("sidebar-report-manager"),
    icon: "cl-icon-clipboard-data-outline",
    id: "/msp/report_manager",
    dataTestId: "msp-report_manager",
    solutionId: SAT_SERVICE,
    permanentPill: {
      variant: "info",
      text: i18n.global.t("status-new"),
    },
    children: [],
  },
];

const CUSTOMER_NAV_ITEMS = [
  {
    order: 4,
    groupBy: SIDENAV_GROUP_BY.EPSILON,
    label: i18n.global.t("sidebar-report-manager"),
    icon: "cl-icon-clipboard-data-outline",
    id: "/customer/report_manager",
    dataTestId: "customer-report_manager",
    solutionId: SAT_SERVICE,
    permanentPill: {
      variant: "info",
      text: i18n.global.t("status-new"),
    },
    children: [],
  },
];

export { MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS };
/* c8 ignore end */
